var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#ed1c24;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1461 -970)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.5,0A12.5,12.5,0,1,1,0,12.5,12.5,12.5,0,0,1,12.5,0Z",
    transform: "translate(1461 970)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-311.509,116.435l-3.166,3.167v-8.132a.769.769,0,0,0-.768-.768.768.768,0,0,0-.768.768V119.6l-3.166-3.166a.767.767,0,0,0-1.086,0,.767.767,0,0,0,0,1.086l4.346,4.346a.753.753,0,0,0,.675.2.756.756,0,0,0,.675-.2l4.346-4.346a.767.767,0,0,0,0-1.086A.77.77,0,0,0-311.509,116.435Z",
    transform: "translate(1788.689 866.299)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.b1023f931486d3cf7d6e51a2c2b1c1fa.svg";
export { ForwardRef as ReactComponent };